import ContactSubItemComponent from './ContactUs_ContactSubItem';
import ComponentHeader from "GeneralComponents/ComponentHeader";
import { IconInfo } from './ContactUs.Interfaces';

interface Props {
    isSideLayout: boolean;
    hasTitle: boolean;
    classForIconArea: string;
    componentTitle: string;
    componentDescription: string;
    secondDescription: string;
    isLightBg: boolean;
    icons: IconInfo[];
}

const ContactUsHeader: React.FC<Props> = ({ isSideLayout, hasTitle, icons, isLightBg, secondDescription, classForIconArea, componentDescription, componentTitle, }) => {

    if (!isSideLayout && hasTitle) {

        return <div className="container pt-5 px-0 mst-ContactUs">

            <ComponentHeader
                disptitle={componentTitle}
                dispdescription={componentDescription}
                light={isLightBg}
            />

        </div>

    }

    return <div className={classForIconArea}>
        {
            (isSideLayout && hasTitle) &&

                <div className="title-box horizontal-fix">

                    <ComponentHeader
                        disptitle={componentTitle}
                        dispdescription={componentDescription}
                        light={true}
                    />

                    <SecondDescription content={secondDescription} />
                
                </div>
        }

        {
            icons.map((icon, idx) =>
                <ContactSubItemComponent
                    key={idx}
                    iconInfo={icon}
                    showIcon={!!icons[0].Icon}
                    hasTopSeperatorLine={false}
                />
            )
        }

    </div>

}

const SecondDescription = ({ content }: { content: string }) => {
    return content && <div className="secondary-title-desc clamp">{content}</div>
}

export default ContactUsHeader;